import React from 'react'

const CustomSwitch = ({ children, showOn }: { children: React.ReactNode; showOn: string[] }) => {
  return showOn.includes(window.location.pathname) ? <>{children}</> : null
}

export default CustomSwitch
